<div class="app-header--bar ion-padding-horizontal text-area--light">
  <div class="app-header--logo">
    <a
      href="/"
      (click)="logoClick($event)"
      [title]="logoActionLabel || fallbackActionLabel"
      [attr.aria-label]="logoActionLabel || fallbackActionLabel"
      class="app-header--logo-link"
    >
      <ion-thumbnail>
        <ion-img
          *ngIf="logoUrl || fallbackLogoUrl"
          [src]="logoUrl || fallbackLogoUrl"
          [alt]="logoActionLabel || fallbackActionLabel"
          role="presentation"
          class="app-header--logo-img"
        ></ion-img>
      </ion-thumbnail>
    </a>
  </div>

  <div class="app-header--title text-style--header">
    <h1
      [title]="title || fallbackTitle"
      class="text-style--header text-style--size-1"
    >
      {{ title || fallbackTitle }}
    </h1>
  </div>

  <div class="app-header--tools no-print">
    <app-translation-options
      [sourceLanguage]="currentLanguage"
      [localeAlternatives]="localeAlternatives"
      [languageOptionsExplanation]="languageOptionsExplanation"
    >
    </app-translation-options>
  </div>
</div>
